// extracted by mini-css-extract-plugin
export default {"box":"box-mdpAO","header":"header-xbCVP","level":"level-DoW9w","hovered":"hovered-HP6ln"};